import { SectionDesign } from '@diritto/common/home/constants/section-constants';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { IkImage } from 'ui-components/Imagekit/IkImage';

type BannerStyle = SectionDesign.LargeRectBanner | SectionDesign.SmallRectBanner;
export type Style = {
  width: number;
  height: number;
  title: string;
  description: string;
};

export const BannerStyles: Record<BannerStyle, Style> = {
  [SectionDesign.LargeRectBanner]: { width: 346, height: 240, title: Typography.Small, description: Typography.XSmall },
  [SectionDesign.SmallRectBanner]: {
    width: 346,
    height: 108,
    title: Typography.XSmall,
    description: Typography.XXSmall,
  },
};

export const StyledItemWrapper = styled.div<{ bannerStyle: Style }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: ${props => props.bannerStyle.width}px;
  height: ${props => props.bannerStyle.height}px;
  border-radius: 6px;

  scroll-snap-align: center;
  scroll-snap-stop: always;

  @media (${isPC}) {
    scroll-snap-align: start;
  }
`;

export const StyledBackgroundImage = styled(IkImage)<{ bannerStyle: Style }>`
  position: absolute;
  width: 100%;
  height: 100%;
  max-width: ${props => props.bannerStyle.width}px;
  max-height: ${props => props.bannerStyle.height}px;
  left: 0;
  top: 0;
  border-radius: 6px;
`;

export const StyledTextWrapper = styled.div<{ bannerStyle: Style }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  width: ${props => props.bannerStyle.width}px;
  height: ${props => props.bannerStyle.height}px;
  padding: 16px;
  border-radius: 6px;
`;

export const StyledTitle = styled.div<{ bannerStyle: Style }>`
  position: relative;
  ${Typography.Small};
  ${props => props.bannerStyle.title};
  font-weight: ${FontWeight.Bold};
  text-shadow: rgba(0, 0, 0, 0.5) 0 0 30px;
  color: ${Color.White};
  max-width: calc(${props => props.bannerStyle.width}px - 32px);
`;

export const StyledDescription = styled.div<{ bannerStyle: Style }>`
  display: flex;
  position: relative;
  ${Typography.XSmall};
  ${props => props.bannerStyle.description};
  text-shadow: rgba(0, 0, 0, 0.5) 0 0 10px;
  font-weight: ${FontWeight.Medium};
  color: ${Color.White};
  max-width: calc(${props => props.bannerStyle.width}px - 32px);
  opacity: 0.6;
`;
